import BasePage from '@/found/components/table_page';

export default {
  name: 'write_off_pending_data',
  extends: BasePage,
  data() {
    return {

    };
  },
  components: {

  },
  async created() {
    await this.getConfigList('main_list');
  },
  methods: {},
};
